<template>
  <div>
    <h3 class="blue-text">{{L10n('customer-quote')}}</h3>
    <form-edit ref="form" :data="data" :model="getModel" @onAutoSave="mixAutoSave" @change="handleFormData"/>
    <button-line
      @click="handleCreate"
    >
      {{isNew ? L10n('create-customer-quote') : L10n('save-customer-quote')}}
    </button-line>
  </div>
</template>

<script>
import { AutoSaveMixin } from '@/mixins/FormAutoSave'
import { ModelRFQ3 } from '@/services/RFQ3s'

export default {
  name: 'index',
  mixins: [AutoSaveMixin],
  components: {
    'form-edit': () => import(/* webpackChunkName: 'QuickRFQPart' */ './Form.vue'),
    'button-line': () => import(/* webpackChunkName: 'UI' */ '@/components/UI/ButtonLine.vue')
  },
  props: {
    isNew: { type: Boolean, required: true },
    data: { type: Object, required: true }
  },
  computed: {
    isAvailableToSave () {
      return !this.isNew
    },
    apiAutoSave () {
      return `RFQ3s/Patch/${this.data.id}`
    }
  },
  methods: {
    getModel () {
      return ModelRFQ3()
    },
    handleFormData (data) {
      this.$emit('update:data', { ...this.data, ...data })
    },
    async handleCreate () {
      const form = this.$refs['form']
      try {
        await form.validate()
        if (this.isNew) {
          this.$emit('onCreate', form.getData())
        } else {
          this.$emit('onSave', form.getData())
        }
      } catch (e) {
        this.validateErrorHandler(e)
      }
    },
    mixSuccessAutoSave (_data, settings) {
      this.$emit('update:data', { ..._data, ...this.data })
    },
    mixErrorAutoSave (_data, settings) {
      this.$emit('update:data', { ...this.data })
    }
  }
}
</script>
